import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';




@Injectable({
    providedIn: 'root'
})
export class ServicosAtualService {
    private baseUrlService: string;

    constructor(private http: HttpClient) {
        this.baseUrlService = environment.URL_API;
    }

    public atualizarServico(dados: any, usuario: string): Observable<any> {
        const url = `${this.baseUrlService}/status/servico/atualizar`;
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': currentUser.token
          }),
          params: new HttpParams()
            .set('usuario', usuario)
        };
    
        return this.http.put<any>(url, dados, httpOptions);
      }

      getUsername(): string {
        return JSON.parse(sessionStorage.getItem('currentUser')).username;
      }
}
